import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import "./index.css";

/** Matches catalog / new-product primary panels (see lovable-catalog-theme --catalog-navy-bg) */
const SUBGROUP_TAB_BG = "rgba(33, 55, 97, 0.85)";

const ProductBar = ({ subgroup, variationItems }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const getColor = (tabIndex) => {
    // Use modulo operator to cycle through colors every 4 tabs
    const cycledIndex = (tabIndex - 1) % 4; // -1 because subgroup is special case

    // Subgroup (category) tab — same navy as product catalog panels
    if (tabIndex === 0) {
      return SUBGROUP_TAB_BG;
    }

    switch (cycledIndex) {
      case 0:
        return "rgba(33, 55, 97, 0.72)";
      case 1:
        return "rgba(33, 55, 97, 0.58)";
      case 2:
        return "rgba(33, 55, 97, 0.44)";
      case 3:
        return "rgba(33, 55, 97, 0.3)";
      default:
        return "rgba(33, 55, 97, 0.44)";
    }
  };

  // Helper function to safely get display value
  const getDisplayValue = (value) => {
    if (typeof value === "string") return value;
    if (typeof value === "object" && value !== null) {
      return value.value || value.name || "";
    }
    return "";
  };

  // Helper function to get subgroup display name
  const getSubgroupName = (subgroup) => {
    if (typeof subgroup === "string") return subgroup;
    if (typeof subgroup === "object" && subgroup !== null) {
      return subgroup.name || "";
    }
    return "";
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: { xs: 320, sm: 480 },
        position: "absolute",
        top: "-20px",
      }}
    >
      <Tabs
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="Product Bar"
        className="product-bar-container"
        TabIndicatorProps={{
          style: { display: "none" },
        }}
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: "rgb(33, 55, 97)",
          },
          "& .Mui-selected": {
            color: "white !important",
          },
        }}
        value={selectedTab}
        onChange={() => {}}
      >
        <Tab
          className="product-bar-tab"
          label={getSubgroupName(subgroup)}
          sx={{
            backgroundColor: getColor(0),
            color: "white",
            fontWeight: "bold",
            zIndex: variationItems?.length + 1 || 1,
          }}
        />
        {variationItems?.map((item, itemIndex) =>
          item.values?.map((val, index) => (
            <Tab
              key={`${itemIndex}-${index}`}
              className="product-bar-tab"
              label={getDisplayValue(val)}
              disabled
              sx={{
                backgroundColor: getColor(index + 1),
                marginLeft: "-15px",
                textTransform: "capitalize",
                color: "white !important",
                zIndex: (variationItems?.length || 1) - index,
              }}
            />
          ))
        )}
      </Tabs>
    </Box>
  );
};

export default ProductBar;
